import {
  OTSalaryComponentListItem,
  UpdateOvertimeComponentVariables,
} from 'api/gql-utils/overtime/types';
import { OvertimeFormData } from './types';

export const convertOTComponentToFormData = (
  component: OTSalaryComponentListItem,
): OvertimeFormData => {
  return {
    name: component.name,
    displayName: component.displayName ?? component.name,
    description: component.description ?? '',
    includeInPfWages: Boolean(component.settings?.pfBehaviour?.includeInPfWages),
    includeInEsiWages: Boolean(component.settings?.esiBehaviour?.includeInEsiWages),
    includeInPtWages: Boolean(component.settings?.ptBehaviour?.includeInPtWages),
    includeInLwfWages: Boolean(component.settings?.lwfBehaviour?.includeInLwfWages),
    includeInGratuityWages: Boolean(component.settings?.gratuityBehaviour?.includeInGratuityWages),
    includeInLeaveEncashmentWages: Boolean(
      component.settings?.leaveEncashmentBehaviour?.includeInLeaveEncashmentWages,
    ),
    taxExemptInOldRegime: Boolean(component.settings?.taxBehaviour?.taxExemptInOldRegime),
    taxExemptInNewRegime: Boolean(component.settings?.taxBehaviour?.taxExemptInNewRegime),
    taxExemptionSection: component.settings?.taxBehaviour?.taxExemptionSection
      ? [component.settings.taxBehaviour.taxExemptionSection]
      : undefined,
    taxDeductionBehaviour: component.settings?.taxBehaviour?.taxDeductionBehaviour ?? undefined,
    supportProration: Boolean(component.settings?.prorationBehaviour?.supportProration),
    considerInArrear: Boolean(component.settings?.arrearBehaviour?.considerInArrear),
  };
};

export const convertFormDataToOTUpdatePayload = (
  formData: Partial<OvertimeFormData>,
): UpdateOvertimeComponentVariables => {
  const taxExemptionSection = Array.isArray(formData.taxExemptionSection)
    ? formData.taxExemptionSection[0]
    : formData.taxExemptionSection;

  return {
    displayName: formData.displayName,
    description: formData.description,
    settings: {
      pfBehaviour: { includeInPfWages: Boolean(formData.includeInPfWages) },
      ptBehaviour: { includeInPtWages: Boolean(formData.includeInPtWages) },
      esiBehaviour: { includeInEsiWages: Boolean(formData.includeInEsiWages) },
      lwfBehaviour: { includeInLwfWages: Boolean(formData.includeInLwfWages) },
      gratuityBehaviour: { includeInGratuityWages: Boolean(formData.includeInGratuityWages) },
      leaveEncashmentBehaviour: {
        includeInLeaveEncashmentWages: Boolean(formData.includeInLeaveEncashmentWages),
      },
      arrearBehaviour: { considerInArrear: Boolean(formData.considerInArrear) },
      taxBehaviour: {
        taxExemptInOldRegime: Boolean(formData.taxExemptInOldRegime),
        taxExemptInNewRegime: Boolean(formData.taxExemptInNewRegime),
        taxExemptionSection: taxExemptionSection ?? '',
        taxDeductionBehaviour: formData.taxDeductionBehaviour!,
      },
      prorationBehaviour: { supportProration: false },
      displayBehaviour: { showZero: false, visibleToEmployee: true },
    },
  };
};
